var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MpcWalletTransactionStatus } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { ethers } from 'ethers';
import { useContext, useEffect, useState } from 'react';
import { CurrencyContext } from '../../context/currency';
import { DialogContext } from '../../context/dialog';
import { UserContext } from '../../context/user';
import { CurrencyTokenSymbol, imxAddressL1AddressMap } from '../../data/currency-tokens/currency-tokens';
import { WalletConnectionType } from '../../types/blockchain';
import { DialogType } from '../../types/dialogs';
import { sleep } from '../../utils/async';
import { getParsedBalances } from '../../utils/balances';
import { useInput } from '../common/use-input';
import { useImxActions } from '../imx/use-imx-actions';
import { useMetamask } from './use-metamask';
export var BlockchainType;
(function (BlockchainType) {
    BlockchainType["IMX"] = "ImmutableX";
    BlockchainType["ETH"] = "Ethereum";
})(BlockchainType || (BlockchainType = {}));
export var blockchainsArray = [BlockchainType.IMX, BlockchainType.ETH];
export function useTransfer() {
    var _this = this;
    var imx = useImxActions();
    var _a = useContext(UserContext), user = _a.user, localWalletAddress = _a.localWalletAddress, balances = _a.balances, getBalances = _a.getBalances;
    var _b = useMetamask(true, 'eth'), metamaskConnected = _b.metamaskConnected, metamaskInitialized = _b.metamaskInitialized, balancesOnEthBC = _b.balancesOnEthBC, getBalancesOnEthBC = _b.getBalancesOnEthBC, transferERC20 = _b.transferERC20, transferETH = _b.transferETH, metamaskErrorMessage = _b.metamaskErrorMessage, setMetamaskErrorMessage = _b.setMetamaskErrorMessage;
    var _c = useContext(CurrencyContext), tokens = _c.tokens, parseCurrencyQuantity = _c.parseCurrencyQuantity;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _d = useState(null), selectedBlockchain = _d[0], setSelectedBlockchain = _d[1];
    var _e = useState(null), selectedTransferFromWallet = _e[0], setSelectedTransferFromWallet = _e[1];
    var _f = useState(null), selectedTransferToWallet = _f[0], setSelectedTransferToWallet = _f[1];
    var _g = useState(null), selectedCurrency = _g[0], setSelectedCurrency = _g[1];
    var _h = useState(undefined), parsedBalances = _h[0], setParsedBalances = _h[1];
    var _j = useState(false), showTransferTokenConfirmationDialog = _j[0], setShowTransferTokenConfirmationDialog = _j[1];
    var _k = useState(null), transferError = _k[0], setTransferError = _k[1];
    var _l = useState(false), transferLoading = _l[0], setTransferLoading = _l[1];
    var _m = useState(false), invalidAddress = _m[0], setInvalidAddress = _m[1];
    var _o = useState(false), addressNotInitOnImx = _o[0], setAddressNotInitOnImx = _o[1];
    var amount = useInput('');
    var externalToWalletAddress = useInput('');
    var estimatedTime = '1-2 min';
    var t = useI18n().t;
    // Get balances on ETH BC only for MPC wallet at initialization
    useEffect(function () {
        getBalancesOnEthBC();
        setTransferError(null);
    }, []);
    // Get balances on Eth BC if metamask is connected and initialized
    useEffect(function () {
        if (metamaskConnected && metamaskInitialized) {
            getBalancesOnEthBC();
            setMetamaskErrorMessage(undefined);
        }
    }, [metamaskInitialized, metamaskConnected]);
    // if fromWallet change, reset amount, externalToWalletAddress and selectedTransferToWallet
    useEffect(function () {
        amount.setValue('');
        externalToWalletAddress.setValue('');
        setSelectedTransferToWallet(null);
        if ((selectedTransferFromWallet === null || selectedTransferFromWallet === void 0 ? void 0 : selectedTransferFromWallet.connectionType) === WalletConnectionType.METAMASK &&
            (selectedTransferFromWallet === null || selectedTransferFromWallet === void 0 ? void 0 : selectedTransferFromWallet.address) === (user === null || user === void 0 ? void 0 : user.coldWalletAddress) &&
            localWalletAddress !== (selectedTransferFromWallet === null || selectedTransferFromWallet === void 0 ? void 0 : selectedTransferFromWallet.address)) {
            setMetamaskErrorMessage(t('error.metamask-custom-wallet-not-active-wallet'));
        }
    }, [selectedTransferFromWallet]);
    // if change currency, reset amount
    useEffect(function () {
        amount.setValue('');
    }, [selectedCurrency]);
    // Listen to externalToWalletAddress input changes and validate it
    useEffect(function () {
        var validateAddress = function () { return __awaiter(_this, void 0, void 0, function () {
            var value, isAddress, addressInitOnImx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        value = externalToWalletAddress.value;
                        if (!value) {
                            setInvalidAddress(false);
                            setAddressNotInitOnImx(false);
                            return [2 /*return*/];
                        }
                        isAddress = ethers.isAddress(value);
                        setInvalidAddress(!isAddress);
                        if (!isAddress) {
                            setAddressNotInitOnImx(false);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, imx.isAddressInitOnImx(value)];
                    case 1:
                        addressInitOnImx = _a.sent();
                        setAddressNotInitOnImx(selectedBlockchain === BlockchainType.IMX && !addressInitOnImx);
                        return [2 /*return*/];
                }
            });
        }); };
        validateAddress();
    }, [externalToWalletAddress.value, selectedBlockchain]);
    useEffect(function () {
        var balance = undefined;
        if (selectedBlockchain === BlockchainType.IMX) {
            var lockedCtaToken = (selectedTransferFromWallet === null || selectedTransferFromWallet === void 0 ? void 0 : selectedTransferFromWallet.connectionType) === WalletConnectionType.MPC ? user === null || user === void 0 ? void 0 : user.ctaTokenCountMpcLocked : '0';
            if (!selectedTransferFromWallet || !balances) {
                balance = undefined;
            }
            else if (selectedTransferFromWallet.address === (user === null || user === void 0 ? void 0 : user.mpcWalletAddress)) {
                balance = balances.cta;
            }
            else if (selectedTransferFromWallet.address === (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress)) {
                balance = balances.game;
            }
            else if (selectedTransferFromWallet.address === (user === null || user === void 0 ? void 0 : user.coldWalletAddress)) {
                balance = balances.custom;
            }
            else if (selectedTransferFromWallet.address === localWalletAddress) {
                balance = balances.local;
            }
            setParsedBalances(balance && user ? getParsedBalances(tokens, parseCurrencyQuantity, balance, lockedCtaToken) : undefined);
        }
        if (selectedBlockchain === BlockchainType.ETH) {
            if ((selectedTransferFromWallet === null || selectedTransferFromWallet === void 0 ? void 0 : selectedTransferFromWallet.connectionType) === WalletConnectionType.METAMASK) {
                if (!metamaskInitialized) {
                    setMetamaskErrorMessage(t('error.metamask-not-initialized'));
                }
                if (!metamaskConnected) {
                    setMetamaskErrorMessage(t('error.metamask-not-connected'));
                }
            }
            if (!selectedTransferFromWallet || !balancesOnEthBC) {
                balance = undefined;
            }
            else if (selectedTransferFromWallet.address === (user === null || user === void 0 ? void 0 : user.mpcWalletAddress)) {
                balance = balancesOnEthBC.cta;
            }
            else if (selectedTransferFromWallet.address === (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress)) {
                balance = balancesOnEthBC.game;
            }
            else if (selectedTransferFromWallet.address === (user === null || user === void 0 ? void 0 : user.coldWalletAddress)) {
                balance = balancesOnEthBC.custom;
            }
            else if (selectedTransferFromWallet.address === localWalletAddress) {
                balance = balancesOnEthBC.local;
            }
            setParsedBalances(balance && user ? getParsedBalances(tokens, parseCurrencyQuantity, balance) : undefined);
        }
    }, [tokens, balances, balancesOnEthBC, selectedTransferFromWallet, user, selectedBlockchain]);
    function initTransfer() {
        return __awaiter(this, void 0, void 0, function () {
            var localTransferError, tokenDecimal, formatedAmount, err_1, ethTransferResponse, parsedObj, erc20TransferResponse, parsedObj, transfertEthResponse, _err_1, transfertERC20Response, err_2, _err_2, message;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        localTransferError = null;
                        tokenDecimal = (_a = tokens === null || tokens === void 0 ? void 0 : tokens.find(function (token) {
                            return token.token_address === (selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.address) ||
                                imxAddressL1AddressMap[token.token_address] === (selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.address);
                        })) === null || _a === void 0 ? void 0 : _a.decimals;
                        formatedAmount = amount.value.replace(',', '');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 27, 28, 29]);
                        setTransferLoading(true);
                        if (!selectedBlockchain ||
                            !selectedTransferFromWallet ||
                            !selectedTransferToWallet ||
                            !selectedCurrency ||
                            !amount.value ||
                            !tokenDecimal) {
                            // TODO errors handlers
                            throw new Error('Missing required fields');
                        }
                        if (!ethers.isAddress(selectedTransferFromWallet.address || '') ||
                            !ethers.isAddress(selectedTransferToWallet.address || '')) {
                            localTransferError = t('error.invalid-eth-address');
                        }
                        if (!(selectedBlockchain === BlockchainType.IMX)) return [3 /*break*/, 8];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, 5, 7]);
                        return [4 /*yield*/, imx.transferERC20({
                                walletFrom: selectedTransferFromWallet,
                                toAddress: selectedTransferToWallet.address,
                                tokenAddress: selectedCurrency.address,
                                quantity: imx.strFloatToTokenQuantity(formatedAmount, tokenDecimal),
                            })];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 4:
                        err_1 = _b.sent();
                        if (err_1 instanceof Error) {
                            if (err_1.message.includes('USER_VERIFIED_REQUIRED')) {
                                localTransferError = t('error.imx.kyc-required');
                            }
                            else if (err_1.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                localTransferError = t('error.imx.cta-token-locked');
                            }
                            else if (err_1.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                localTransferError = t('error.imx.asset-locked');
                            }
                            else {
                                localTransferError = t('error.generic');
                            }
                        }
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, sleep(4000)];
                    case 6:
                        _b.sent();
                        getBalances();
                        return [7 /*endfinally*/];
                    case 7: return [3 /*break*/, 26];
                    case 8:
                        if (!(selectedBlockchain === BlockchainType.ETH)) return [3 /*break*/, 26];
                        if (!(selectedTransferFromWallet.connectionType === WalletConnectionType.MPC)) return [3 /*break*/, 16];
                        if (!(selectedCurrency.symbol === CurrencyTokenSymbol.ETH)) return [3 /*break*/, 12];
                        return [4 /*yield*/, imx.mpcTransferETH({
                                walletFrom: selectedTransferFromWallet,
                                toAddress: selectedTransferToWallet.address,
                                quantity: imx.strFloatToTokenQuantity(formatedAmount, tokenDecimal),
                            })];
                    case 9:
                        ethTransferResponse = _b.sent();
                        if (!ethTransferResponse) return [3 /*break*/, 11];
                        if (!(ethTransferResponse.status === MpcWalletTransactionStatus.FAILED)) return [3 /*break*/, 11];
                        if (!ethTransferResponse.error) return [3 /*break*/, 11];
                        parsedObj = JSON.parse(ethTransferResponse.error);
                        console.log('in parsedObjError', parsedObj === null || parsedObj === void 0 ? void 0 : parsedObj.shortMessage);
                        return [4 /*yield*/, (parsedObj === null || parsedObj === void 0 ? void 0 : parsedObj.shortMessage)];
                    case 10:
                        localTransferError = (_b.sent()) || t('error.generic');
                        _b.label = 11;
                    case 11: return [3 /*break*/, 15];
                    case 12: return [4 /*yield*/, imx.mpcTransferERC20({
                            walletFrom: selectedTransferFromWallet,
                            toAddress: selectedTransferToWallet.address,
                            tokenAddress: selectedCurrency.address,
                            quantity: imx.strFloatToTokenQuantity(formatedAmount, tokenDecimal),
                        })];
                    case 13:
                        erc20TransferResponse = _b.sent();
                        if (!erc20TransferResponse) return [3 /*break*/, 15];
                        if (!(erc20TransferResponse.status === MpcWalletTransactionStatus.FAILED)) return [3 /*break*/, 15];
                        if (!erc20TransferResponse.error) return [3 /*break*/, 15];
                        parsedObj = JSON.parse(erc20TransferResponse.error);
                        console.log('in parsedObjError', parsedObj === null || parsedObj === void 0 ? void 0 : parsedObj.shortMessage);
                        return [4 /*yield*/, (parsedObj === null || parsedObj === void 0 ? void 0 : parsedObj.shortMessage)];
                    case 14:
                        localTransferError = (_b.sent()) || t('error.generic');
                        _b.label = 15;
                    case 15: return [3 /*break*/, 26];
                    case 16:
                        if (!(selectedTransferFromWallet.connectionType === WalletConnectionType.METAMASK)) return [3 /*break*/, 26];
                        if (!(selectedCurrency.symbol === 'ETH')) return [3 /*break*/, 22];
                        _b.label = 17;
                    case 17:
                        _b.trys.push([17, 19, 20, 21]);
                        return [4 /*yield*/, transferETH(selectedTransferToWallet.address, formatedAmount)];
                    case 18:
                        transfertEthResponse = _b.sent();
                        if (!transfertEthResponse) {
                            localTransferError = t('error.generic');
                        }
                        return [3 /*break*/, 21];
                    case 19:
                        _err_1 = _b.sent();
                        localTransferError = t('error.generic');
                        return [3 /*break*/, 21];
                    case 20:
                        getBalancesOnEthBC();
                        return [7 /*endfinally*/];
                    case 21: return [3 /*break*/, 26];
                    case 22:
                        _b.trys.push([22, 24, 25, 26]);
                        return [4 /*yield*/, transferERC20(selectedCurrency.address, selectedTransferToWallet.address, formatedAmount)];
                    case 23:
                        transfertERC20Response = _b.sent();
                        if (!transfertERC20Response) {
                            localTransferError = t('error.generic');
                        }
                        return [3 /*break*/, 26];
                    case 24:
                        err_2 = _b.sent();
                        console.log(err_2, 'err');
                        return [3 /*break*/, 26];
                    case 25:
                        getBalancesOnEthBC();
                        return [7 /*endfinally*/];
                    case 26: return [3 /*break*/, 29];
                    case 27:
                        _err_2 = _b.sent();
                        localTransferError = t('error.generic');
                        return [3 /*break*/, 29];
                    case 28:
                        // If all ok, reset all previous datas
                        setSelectedTransferFromWallet(null);
                        setSelectedTransferToWallet(null);
                        setSelectedCurrency(null);
                        setShowTransferTokenConfirmationDialog(false);
                        amount.setValue('');
                        message = localTransferError ? localTransferError : t('manage-tokens.transfer.transfer-success-message');
                        setTransferLoading(false);
                        setTransferError(localTransferError);
                        setDialogProps({
                            common: {
                                title: localTransferError ? 'Error' : t('manage-tokens.transfer.transfer-success-title'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: message,
                            },
                        });
                        return [7 /*endfinally*/];
                    case 29: return [2 /*return*/];
                }
            });
        });
    }
    return {
        selectedBlockchain: selectedBlockchain,
        setSelectedBlockchain: setSelectedBlockchain,
        setSelectedTransferFromWallet: setSelectedTransferFromWallet,
        selectedTransferFromWallet: selectedTransferFromWallet,
        setSelectedTransferToWallet: setSelectedTransferToWallet,
        selectedTransferToWallet: selectedTransferToWallet,
        setSelectedCurrency: setSelectedCurrency,
        selectedCurrency: selectedCurrency,
        parsedBalances: parsedBalances,
        amount: amount,
        estimatedTime: estimatedTime,
        initTransfer: initTransfer,
        transferLoading: transferLoading,
        transferError: transferError,
        showTransferTokenConfirmationDialog: showTransferTokenConfirmationDialog,
        setShowTransferTokenConfirmationDialog: setShowTransferTokenConfirmationDialog,
        externalToWalletAddress: externalToWalletAddress,
        invalidAddress: invalidAddress,
        addressNotInitOnImx: addressNotInitOnImx,
        metamaskErrorMessage: metamaskErrorMessage,
    };
}
